module.exports = __webpack_public_path__ + "media/images/menu/columba-895fce81b07a2efe03ebd2c4612b37ea.jpg";